module.exports = __webpack_public_path__ + "img/sm-logo.fa082816.png";